module.exports = __webpack_public_path__ + "static/media/STP_BI_Logo.94c30bdc.png";